import React from 'react'
import { Link } from 'react-router-dom'
import FormSF from '../../../widgets/form/FormSF'
import CardUI from '../../../widgets/layout/CardUI'
import BadgeUI from '../../../widgets/output/BadgeUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import ButtonTinyUI from '../../../widgets/action/ButtonTinyUI'
import ButtonTinyWithSpinnerUI from '../../../widgets/action/ButtonTinyWithSpinnerUI'
import FileUploadModalSF from '../../../widgets/form/FileUploadModalSF'

const ITRDataCollectionUI = ({ context, account,
  onITRSubmit, itrSubmitted, itrSuccessMsg, itrErrorList, itrFileList,
  onSkipCollectionITR, skipCollectionModeITR,
  itrSkippedSuccessMsg, itrSkippedErrorList,
  onDownloadFileClick, fileErrorList,
  itrReuploadSubmitted, onITRReuploadClick,
  itrJsonUploadMode, onItrJsonUploadClick, onItrJsonCancelUploadClick, onItrJsonUpload,
  itrExcelUploadMode, onItrExcelUploadClick, onItrExcelCancelUploadClick, onItrExcelUpload
}) =>
  <CardUI title='ITR data collection' className='g_m_top_100'>
    <div className='g_flex_h g_flex_top'>
      <div className='g_flex_v'>
        {
          account.documentStatus.itrReferenceId &&
          <span className='g_muted'>Ref id: {account.documentStatus.itrReferenceId}</span>
        }
        {
          // account.documentStatus.itrReceiveStatus === 'collected' &&
          <>
            {
              itrFileList != null && itrFileList.map((item) =>
                <Link className='g_m_right_50' onClick={onDownloadFileClick} to='#' data-type='itr' data-file-name={item}>
                  {item}
                </Link>)
              //<span>{item}<br></br></span>)
            }
            {
              fileErrorList && fileErrorList.length > 0 &&
              <span>{fileErrorList[0].message}</span>
            }
          </>
        }
      </div>
      <div className='g_flex_v g_text_right'>
        <span><BadgeUI label={account.documentStatus.itrReceiveStatus} /></span>
        {
          account.documentStatus.itrReceiveStatus !== 'not_initiated' &&
          <span className='g_muted'>{account.documentStatus.itrStatusDateF1}</span>
        }
      </div>
    </div>

    {
      (account.documentStatus.itrReceiveStatus === 'collected' || account.documentStatus.itrReceiveStatus === "skipped") &&
      context.permissions.includes('su_manage') &&
      <div className='g_flex_h g_flex_top g_m_top_50'>
        <span className='g_muted'>If ITR data needs to be collected again, click the button:</span>
        <FormSF context={context} buttonLabel='Enable Collection of ITR Data'
          onSubmit={onITRSubmit} busy={itrSubmitted}
          successMsg={itrSuccessMsg} errorList={itrErrorList}
          inlineButton={true}
        />
      </div>
    }
    {
      context.permissions.includes('su_manage') &&
      account.documentStatus.itrReceiveStatus !== 'collected' &&
      account.documentStatus.itrReceiveStatus !== 'skipped' &&

      <div className='g_flex_h g_m_top_50'>
        <span className='g_muted'>If ITR data is not available, skip ITR collection</span>
        <div className='g_flex_h g_flex_right g_text_right'>
          <ButtonTinyUI label='Skip collection' onClick={onSkipCollectionITR} />
          <SpinnerUI className='g_m_left_50' show={skipCollectionModeITR} />
        </div>
      </div>
    }
    <span>{itrSkippedSuccessMsg}</span>
    <ButtonTinyWithSpinnerUI className='g_m_top_25 g_text_right'
      label='Reupload ITR data from S3 to DB'
      onClick={onITRReuploadClick} alignLeft={false}
      busy={itrReuploadSubmitted}
    />
    {
      context.permissions.includes('su_superuser_business') &&
      <>
        <ButtonTinyWithSpinnerUI className='g_m_top_25 g_text_right'
          label='Upload ITR JSON file'
          onClick={onItrJsonUploadClick} alignLeft={false}
        />
        <ButtonTinyWithSpinnerUI className='g_m_top_25 g_text_right'
          label='Upload ITR Excel file'
          onClick={onItrExcelUploadClick} alignLeft={false}
        />
      </>
    }

    <FileUploadModalSF
      context={context}
      uploadMode={itrJsonUploadMode}
      onCancelClick={onItrJsonCancelUploadClick}
      signedUrlApi={`/api/su/accounts/${account.accountId}/itrReport/json/fileUploadSignedUrl`}
      onUpload={onItrJsonUpload}
    />

    <FileUploadModalSF
      context={context}
      uploadMode={itrExcelUploadMode}
      onCancelClick={onItrExcelCancelUploadClick}
      signedUrlApi={`/api/su/accounts/${account.accountId}/itrReport/excel/fileUploadSignedUrl`}
      onUpload={onItrExcelUpload}
    />
  </CardUI>

export default ITRDataCollectionUI